import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollProgress from '../components/ScrollProgress';
import HeroSection from '../components/HeroSection';
import QuickInfo from '../components/QuickInfo';
import ContentTabs from '../components/ContentTabs';
import StatsSection from '../components/StatsSection';
import PricingSection from '../components/PricingSection';
import LocationSection from '../components/LocationSection';
import TestimonialsSection from '../components/TestimonialsSection';
import GallerySection from '../components/GallerySection';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <>
      <ScrollProgress />
      <Header />
      <main>
        <HeroSection />
        <QuickInfo />
        <StatsSection />
        <ContentTabs />
        <PricingSection />
        <TestimonialsSection />
        <LocationSection />
        <GallerySection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
